import { Component } from '@opten/compiler/metadata/component';
import { getParentWithClass } from '@opten/dom/get-parent-with-class';
import { getSiblings } from '@opten/dom/get-siblings';
import { getParents } from '@opten/dom/get-parents';
import { hasClass } from '@opten/dom/has-class';


@Component({ className: 'js-checkbox-tree', observe: true })
export class CheckboxTreeComponent {
	constructor(private element: HTMLElement) {
		const checkboxes = this.getCheckboxesFromContainer(this.element);
		if (checkboxes && checkboxes.length > 0) {
			checkboxes.filter(o => o.checked).forEach(o => this.handleCheckboxChanged(o));
			checkboxes.forEach(o => o.addEventListener('change', () => this.handleCheckboxChanged(o)));
		}
	}

	private handleCheckboxChanged(checkbox: HTMLInputElement) {
		const checked = checkbox.checked;
		const container = this.getContainerForElement(checkbox);

		if (container) {
			this.updateCheckboxesForContainer(container, checked);
			this.updateSiblings(container, checked);
		}
	}

	private updateCheckboxesForContainer(container: HTMLElement, checked: boolean, indeterminate = false, onlyChildren = false) {
		const checkboxes = this.getCheckboxesFromContainer(container, onlyChildren);
		if (checkboxes && checkboxes.length > 0) {
			checkboxes.forEach(o => {
				o.indeterminate = indeterminate;
				o.checked = checked;
			})
		}
	}

	private updateSiblings(child: HTMLElement, checked: boolean) {
		const parent = this.getContainerForElement(child);
		const siblings = getSiblings(child);
		let all = true;
		let indeterminate = false;

		if (siblings && siblings.length > 0) {
			siblings.forEach(sibling => {
				const checkboxes = this.getCheckboxesFromContainer(sibling, true);
				if (checkboxes && checkboxes.length > 0) {
					all = all && checkboxes.filter(o => o.checked === checked).length === checkboxes.length;
				}
			});
		}

		if (all && checked) {
			if (parent) {
				this.updateCheckboxesForContainer(parent, checked, false, true);
				this.updateSiblings(parent, checked);
			}

		}
		else if (all && !checked) {
			if (parent) {
				const checkboxesTree = this.getCheckboxesFromContainer(parent);
				if (checkboxesTree && checkboxesTree.length > 0) {
					indeterminate = checkboxesTree.filter(o => o.checked).length > 0;
				}
				this.updateCheckboxesForContainer(parent, checked, indeterminate, true);
				this.updateSiblings(parent, checked);
			}
		}
		else {
			const parents = this.getContainersForElement(child);
			if (parents && parents.length > 0) {
				parents.forEach(o => this.updateCheckboxesForContainer(o, false, true, true));
			}
		}
	}

	private getContainersForElement(child: HTMLElement): HTMLElement[] {
		var parents = getParents(child);
		parents = parents.filter(o => hasClass(o, 'js-checkbox-tree-elements'));
		return parents;
	}

	private getContainerForElement(child: HTMLElement): HTMLElement {
		return getParentWithClass(child, 'js-checkbox-tree-elements');
	}

	private getCheckboxesFromContainer(container: HTMLElement, onlyChildren = false): HTMLInputElement[] {
		return onlyChildren ?
			Array.from(this.queryDirectChildren(container, '.js-checkbox-tree-element')) as HTMLInputElement[] :
			Array.from(container.getElementsByClassName('js-checkbox-tree-element')) as HTMLInputElement[];
	}

	private queryDirectChildren(parent: HTMLElement, selector) {
		const nodes = Array.from(parent.querySelectorAll(selector));
		const filteredNodes = nodes.filter(element => element.parentElement === parent);
		return filteredNodes;
	}



}

